
import { GetColumnconfig } from '../../Asset/httpMethod';
import generateExcel from '../../Components/Grid/ExcelGenerator';
import { AlertPopup } from '../../Asset/common';

export const ExcelGenerate = async (MenuCode, data, Setting) => {
  try {
    let ColumnConfig = await GetColumnconfig(MenuCode);
    console.log('ColumnConfig', ColumnConfig);
    if (ColumnConfig && ColumnConfig.length > 0) {
      const filteredColumns = ColumnConfig
        ?.filter(column => column.IsExcelHide == false)
        ?.sort((a, b) => a.ExcelOrd - b.ExcelOrd);

      let isKeyPresent = data.some(el => {
        if (el.hasOwnProperty('SELECTED'))
          return true;
      })

      if (isKeyPresent) {
        let hasTrueSelected = data.some(x => x.SELECTED == true);
        if (hasTrueSelected) {
          data = data.filter(x => x.SELECTED == true);
        }
      }

      await generateExcel(filteredColumns, data, 'example.xlsx', Setting);
    } else {
      AlertPopup.errorPopup('No column configuration available.');
    }
  } catch (err) {
    AlertPopup.errorPopup(err.message || 'An error occurred while generating the Excel file.');
  }
}